import React, { Suspense } from "react";
import { useSelector } from "react-redux";
import { HelmetProvider, Helmet } from "react-helmet-async";
import DateFnsUtils from "@date-io/date-fns";
import Routes from "./routes/Routes";

import { ThemeProvider } from "styled-components/macro";
import { create } from "jss";

import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import {
  StylesProvider,
  ThemeProvider as MuiThemeProvider,
  jssPreset,
} from "@material-ui/core/styles";

import create_Theme from "./theme";
import {
  getSessionExpiredEventName,
  hasActiveSession,
} from "./utils/sessionAuth";
import { useTranslation } from "react-i18next";
import { synchronizeProfileLocale } from "./services/localizationService";
import AppErrorBoundary from "./components/AppErrorBoundary";
import AppLoadingScreen from "./components/AppLoadingScreen";

const jss = create({
  ...jssPreset(),
  insertionPoint: document.getElementById("jss-insertion-point"),
});

function App() {
  const theme = useSelector((state) => state.themeReducer);
  const { t } = useTranslation();

  React.useEffect(() => {
    synchronizeProfileLocale();
    const intervalId = window.setInterval(() => {
      hasActiveSession();
    }, 60000);

    const handleSessionExpired = () => {
      window.clearInterval(intervalId);
    };

    window.addEventListener(getSessionExpiredEventName(), handleSessionExpired);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener(
        getSessionExpiredEventName(),
        handleSessionExpired
      );
    };
  }, []);

  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet
          titleTemplate="%s | WifiAds"
          defaultTitle={t("app.clientTitle", "WifiAds - Clientes")}
        />

        <StylesProvider jss={jss}>
          {/* Para habilitar Componentes tipos Picker en Childs nodes react tree */}
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <MuiThemeProvider theme={create_Theme(theme.currentTheme)}>
              <ThemeProvider theme={create_Theme(theme.currentTheme)}>
                <AppErrorBoundary>
                  <Suspense
                    fallback={
                      <AppLoadingScreen
                        message={t(
                          "common.loadingWorkspace",
                          "Cargando su espacio de trabajo..."
                        )}
                      />
                    }
                  >
                    <Routes />
                  </Suspense>
                </AppErrorBoundary>
              </ThemeProvider>
            </MuiThemeProvider>
          </MuiPickersUtilsProvider>
        </StylesProvider>
      </HelmetProvider>
    </React.Fragment>
  );
}

export default App;
